export default __webpack_public_path__ + "content/media/30.b03da166.jpg";